import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { unfollowUser } from "../../../actions/friend";
import { removeUserFollowedNotifications } from "../../../actions/notification";

const CancelFollowEmployer = ({
  match,
  unfollowUser,
  removeUserFollowedNotifications,
  setcancelfollowemployeroverlay,
  profile: { user, avatar, firstname, lastname, companyname, location },
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() =>
              setcancelfollowemployeroverlay({ request: false, confirm: false })
            }
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">{companyname}</span>
                </li>
                <li className="user-online-item">
                  {firstname} {lastname}
                </li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text">
            Would you like to unfollow{" "}
            <span className="blue bold">
              {firstname} {lastname}
            </span>{" "}
            of <span className="blue bold">{companyname}</span>?
          </div>
          <div className="flex-center">
            <button
              className="user-request-button background-blue"
              onClick={() =>
                unfollowUser({ user }) &&
                removeUserFollowedNotifications(match.params.channelid) &&
                setcancelfollowemployeroverlay({
                  request: false,
                  confirm: true,
                })
              }
            >
              <i className="far fa-check-circle fa-sm mr-5"></i>
              Confirm
            </button>
            <button
              className="user-request-button background-blue"
              onClick={() =>
                setcancelfollowemployeroverlay({
                  request: false,
                  confirm: false,
                })
              }
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

CancelFollowEmployer.propTypes = {
  auth: PropTypes.object.isRequired,
  unfollowUser: PropTypes.func.isRequired,
  removeUserFollowedNotifications: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  friend: state.friend,
});

export default connect(mapStateToProps, {
  unfollowUser,
  removeUserFollowedNotifications,
})(CancelFollowEmployer);
